import React, { useState, useEffect } from "react";
import {
  Switch,
  Route,
  Redirect,
  Link,
  useHistory,
  useLocation,
} from "react-router-dom";
import { Spin, Layout, Card, Menu, Button, Dropdown, Select } from "antd";
import {
  DownOutlined,
  BarChartOutlined,
  CloudOutlined,
  ShopOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { GET_ADMIN_INFO, REFRESH_ADMIN_TOKEN, LOGIN_OUT } from "../api/login";
import { TREE } from "../api/menu";

import cookie from "react-cookies";
import "./index.less";

import ContHeader from "../components/ContHeader";
import ContBreadcrumb from "../components/ContBreadcrumb";
//公共函数
import { array2tree } from "../common/utils";

//页面引入
// import Overview from "./overview/list.js"; //概览
import TaskList from "./task/list"; //任务列表
import TaskCreate from "./task/create"; //创建任务
import TaskDetail from "./task/detail"; //任务详情
import LogList from "./log/list"; //消费记录
import My from "./my/list"; //个人信息

import { useTranslation } from "react-i18next";

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const Minishop = (props) => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [menus, setMenus] = useState([
    {
      icon: "add.svg",
      key: "/task/create",
      label: t("menu.createTask"),
      url: "/task/create",
    },
    {
      icon: "add-subset.svg",
      key: "/task/list",
      label: t("menu.task"),
      url: "/task/list",
    },
    // {
    //   icon: "config.svg",
    //   key: "/log/list",
    //   label: t("menu.log"),
    //   url: "/log/list",
    // },
  ]);
  const [userInfo, setUserInfo] = useState({});
  const [selectedKeys, setSelectedKeys] = useState("");

  const history = useHistory();
  const location = useLocation();

  const [cur, setCur] = useState("en");

  useEffect(() => {
    setCur(localStorage.getItem("i18nextLng"));
  }, [localStorage.getItem("i18nextLng")]);

  useEffect(async () => {
    document.title = t("WEBTitle");
    await isLogin();
    await getUserInfo();
    await getMenuTree();

    setSelectedKeys(location.pathname.split("/index")[1]);
  }, []);

  const isLogin = async () => {
    if (!cookie.load("accessToken")) {
      cookie.remove("accessToken", { path: "/" });
      localStorage.removeItem("userInfo");
      history.push("/login");
      return true;
    }
    return false;
  };

  const getUserInfo = async () => {
    setUserInfo(
      localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {}
    );
  };
  const getMenuTree = async () => {
    // const { data } = await TREE();
    // if (data.data.length) {
    setMenus(
      [...modifyMenu(menus)].map((item) => ({
        ...item,
      }))
    );
    // }
  };

  /**
   * 递归函数，用于给树型菜单统一修改和添加参数。
   *
   * @param {Array} menu - 树型菜单数据。
   * @param {Object} parent - 父级数据
   * @return {Array} 修改后的树型菜单数据。
   */
  const modifyMenu = (menu, parent) => {
    return (
      menu &&
      menu.map((item) => {
        const newItem = { ...item };
        newItem.pathKey = newItem.key;
        newItem.key = newItem.key;
        if (newItem.icon) {
          newItem.icon = (
            <img
              src={require(`../assets/image/icon/${newItem.icon}`).default}
              style={{ width: 18 }}
            />
          );
        }
        // console.log(newItem);
        if (!!parent?.path) {
          newItem.path = [...parent?.path];
        } else {
          newItem.path = [];
        }

        newItem.path.push(newItem.pathKey);

        if (newItem.child) {
          newItem.child = modifyMenu(newItem.child, newItem);
        }

        if (newItem?.child?.length) {
          newItem.label = newItem.label;
          newItem.children = [...newItem.child];
        } else {
          newItem.label = (
            <a href={`/index${newItem.url}`}>{newItem.label}</a>
          );
        }

        return newItem;
      })
    );
  };

  const userItems = [
    {
      key: 0,
      label: (
        <Button
          type="link"
          className="p-0 text-gray"
          onClick={() => {
            localStorage.removeItem("userInfo");
            cookie.remove("accessToken");
            cookie.remove("accessToken", { path: "/" });
            cookie.remove("accessToken", { path: "*" });
            cookie.remove("userInfo");
            cookie.remove("userInfo", { path: "/" });
            cookie.remove("userInfo", { path: "*" });
            history.push("/login");
          }}
        >
          {t("header.out")}
        </Button>
      ),
    },
  ];

  const changeLanguage = (key) => {
    i18n.changeLanguage(key);
    window.location.reload();
  };

  return (
    <Spin spinning={loading}>
      <Layout hasSider>
        <Sider
          style={{
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
          }}
        >
          <div
            className="logo"
            style={{ padding: "5px 0", textAlign: "center" }}
          >
            <img
              src={require("../assets/image/logo.jpg").default}
              style={{ width: "100%" }}
            />
          </div>

          <Menu
            theme="dark"
            mode="inline"
            // defaultSelectedKeys={[selectedKeys]}
            selectedKeys={[selectedKeys]}
            items={[...menus]}
            // onSelect={(e) => {
            //   // console.log(e);
            //   setSelectedKeys(e.key);
            // }}
          />
        </Sider>
        <Layout className="site-layout" style={{ marginLeft: 200 }}>
          <Header
            className="site-layout-background"
            style={{ padding: 0, background: "#fff" }}
          >
            <div className="d-flex justify-content-between align-item-center px-3">
              <div>
                {/* <span>
                  <Button
                    type="link"
                    size="small"
                    onClick={() => {
                      changeLanguage("zh_CN");
                    }}
                  >
                    {t("language.zh")}
                  </Button>
                  /
                  <Button
                    type="link"
                    size="small"
                    onClick={() => {
                      changeLanguage("en");
                    }}
                  >
                    {t("language.en")}
                  </Button>
                </span> */}

                <Select
                  value={cur}
                  bordered={false}
                  style={{ width: "120px", textAlign: "center" }}
                  options={[
                    {
                      label: "English",
                      value: "en",
                    },
                    {
                      label: "简体中文",
                      value: "zh_CN",
                    },
                  ]}
                  onSelect={(key) => {
                    // console.log(key);
                    changeLanguage(key);
                  }}
                />
              </div>
              <div>
                <Dropdown
                  menu={{
                    items: userItems,
                  }}
                >
                  <div style={{ cursor: "pointer" }}>
                    {(userInfo &&
                      `${userInfo.nickname} · ${userInfo.username}`) ||
                      "-"}
                  </div>
                </Dropdown>
              </div>
            </div>
          </Header>
          <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
            <Switch>
              {/* 概览 */}
              {/* <Route path="/index/overview" exact component={Overview} /> */}
              {/* 创建任务 */}
              <Route path="/index/task/create" exact component={TaskCreate} />
              {/* 任务详情 */}
              <Route path="/index/task/detail" exact component={TaskDetail} />
              {/* 任务列表 */}
              <Route path="/index/task/list" exact component={TaskList} />
              {/* 消费记录 */}
              <Route path="/index/log/list" exact component={LogList} />
              {/* 个人中心 */}
              <Route path="/index/my/list" exact component={My} />

              <Redirect to={`/index/task/create`} />
            </Switch>
          </Content>
          {/* <Footer style={{ textAlign: "center", background: "transparent" }}>
            Copyright © 2022 宿州七朵信息技术有限公司 沪ICP备2020033741号-1
          </Footer> */}
        </Layout>
      </Layout>
    </Spin>
  );
};

export default Minishop;
